import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map, catchError } from 'rxjs/operators';
import { Loyaltic } from '../helpers/api-url.constants';
import { AuthService } from '../helpers/auth.service';
import { LoaderService } from '../helpers/loader.service';
import { Router } from '@angular/router';

@Injectable()
export class LoyalticInterceptor implements HttpInterceptor {
    private isHandlingUnauthorized = false;
    private isGeoRestricted = false;

    constructor(private authService: AuthService, private loader: LoaderService, private router: Router) { }

    usersData = {
      "data":"data"
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // If geo-restricted, block all API calls
        if (this.isGeoRestricted) {
            this.loader.hide();
            return throwError(() => new HttpErrorResponse({
                status: 403,
                statusText: 'Geo-restricted',
                error: { message: 'This service is only available from Finland.' }
            }));
        }

        if (request.url.indexOf(environment.baseUrl + Loyaltic.API.LoginWithUploadReceipt) === -1 &&
            request.url.indexOf(environment.baseUrl + Loyaltic.API.Upload) === -1 &&
            request.url.indexOf(environment.baseUrl + Loyaltic.API.Participate) === -1 &&
            request.url.indexOf(environment.baseUrl + Loyaltic.API.CaptureDigitalWin) === -1) {
            request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
            request = request.clone({ headers: request.headers.set('Accept', 'application/json') });
        }
        const token = this.authService.getToken();
        if (token) {
            request = request.clone({ headers: request.headers.set('Authorization', `Bearer ${token}`) });
        }
        request = request.clone({ headers: request.headers.set('ApiKey', `49D7253EC1384D1339CE24786C137`) });

        if (this.loader.isShowLoader) {
            this.loader.show();
        }
        return next.handle(request).pipe(
            map(resp => {
                if (resp instanceof HttpResponse) {
                    this.loader.isShowLoader = true;
                    this.loader.hide();
                }
                return resp;
            }),
            catchError((error: HttpErrorResponse) => {
                this.loader.hide();

                // Check if this is a geo-restriction error
                if (error.status === 403 &&
                    error.error?.message === 'This service is only available from Finland.') {
                    if (!this.isGeoRestricted) {
                        this.isGeoRestricted = true;
                        // Don't navigate, let the component handle displaying the message
                    }
                    return throwError(() => error);
                }

                // Handle regular unauthorized errors (token expiration, etc.)
                if (error.status === 401 || error.status === 403) {
                    if (!this.isHandlingUnauthorized) {
                        this.isHandlingUnauthorized = true;
                        this.authService.resetTokens();
                        this.router.navigate(['home']).then(() => {
                            // Reset flag after navigation completes
                            setTimeout(() => this.isHandlingUnauthorized = false, 1000);
                        });
                    }
                }

                return throwError(() => error);
            })
        );
    }
}
